// extracted by mini-css-extract-plugin
export default {"table":"OrderTable_table__pjlmj","totalPrice":"OrderTable_totalPrice__rPhks"};